// V8.11 — Tier colors extrait de RankSection (supprimé) pour partage avec RankBadge
export const TIER_COLORS = {
  IRON:        '#71717a',
  BRONZE:      '#b45309',
  SILVER:      '#a1a1aa',
  GOLD:        '#eab308',
  PLATINUM:    '#06b6d4',
  EMERALD:     '#10b981',
  DIAMOND:     '#a855f7',
  MASTER:      '#a855f7',
  GRANDMASTER: '#ef4444',
  CHALLENGER:  '#ef4444',
};
